import {Injectable, Injector} from "@angular/core";
import {SimSystemService} from "../../../api/generated/service";

@Injectable({
	providedIn: "root",
})
export class SimSystemExtendedService extends SimSystemService {
	/**
	 * settings to get proxy configurations {@link SimConfigurationService}
	 */
	constructor(injector: Injector) {
		super(injector);
	}

	// Returns unix time in milliseconds
	// See: https://stackoverflow.com/questions/221294/how-do-you-get-a-timestamp-in-javascript
	public getTimestamp() {
		let timeStampInMs: number;

		//SIMSOFT-8006 ASturl 21.11.2022
		//Performance.now causing huge offset in Recording Window under unknown conditions
		/*
		if (window.performance && window.performance.now && window.performance.timeOrigin) {
			timeStampInMs = window.performance.now() + window.performance.timeOrigin;
		} else {
			// https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Date/now
			timeStampInMs = Date.now();
		}*/

		timeStampInMs = Date.now();

		return timeStampInMs;
	}

	// Returns the difference between local and system time in milliseconds.
	// If the offset is negative the localtime is ahead of the system time und vice versa.
	public getLocalTimeOffset(): Promise<number> {
		let localTime = this.getTimestamp();
		return this.getSystemTime().then(
			(getSystemTimeResult) => {
				let offset: number;

				offset = getSystemTimeResult - localTime;
				return offset;
			},
			() => {
				return 0;
			},
		);
	}
}
